import styled from "styled-components";
import { Modal as AntModal } from "antd";

export const Modal = styled(AntModal)`

.ant-modal-content {
	text-align: center;
	padding-top: 116px !important;
}

.ant-modal-title {
	font-size: 18px;
}

.ant-modal-footer {
	.ant-btn-default {
		display: none;
	}
}
	
#modal-icon {
	width: 100px !important;
    top: -10px !important;
}
`;

export const AmountText = styled.div`
margin: 10px 0;
display: flex;
height: 50px;
padding: 8px 16px;
justify-content: center;
align-items: center;
gap: 6px;
background: linear-gradient(90deg, rgba(255, 214, 71, 0.00) 0%, #FFD647 50%, rgba(255, 214, 71, 0.00) 100%);
backdrop-filter: blur(25px);

font-size: 20px;
font-weight: 700;
color: #1e1e1e;
`;

export const ExpiredText = styled.div`
	width: 90%;
	font-size: 12px;
	font-weight: 400;
	line-height: 18.26px;
	color: #FFF;
	margin: 20px auto 0;
	@media screen and (max-width: 413px) {
		font-size: 8px;
		font-weight: 600;
		line-height: 15px;
	}
`;

